export default "__VITE_ASSET__Cj9X8lmc__"